import { required, minLength2, maxLength100 } from "validators";
export {
	trim,
	noSpace,
	trimMidSentence,
	normalizeAll,
	normalizeDbaName,
} from "validators";

export const validateLegalBusinessName = [required, minLength2, maxLength100];

export const validateDoingBusinessAs = [required, minLength2, maxLength100];
